var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.938 2.48c2.82 0 4.392 1.157 5.194 2.584.833 1.482.898 3.375.432 4.88-.473 1.527-1.745 3.465-3.071 5.055-.655.786-1.3 1.458-1.826 1.925a5.482 5.482 0 0 1-.652.51c-.026.018-.05.032-.071.044a1.86 1.86 0 0 1-.068-.042 5.613 5.613 0 0 1-.648-.524c-.525-.48-1.167-1.165-1.817-1.96-1.318-1.614-2.564-3.547-2.987-4.994C4 8.5 4.014 6.596 4.8 5.096 5.55 3.665 7.062 2.48 9.938 2.48zm-.105 15.053.005-.002-.005.002zm.216 0z",
    fill: "#525266",
    stroke: "#525266",
    strokeWidth: 1.627
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7.5,
    r: 2.5,
    fill: "#fff"
  })));
};
export default __webpack_public_path__ + "static/media/icon-location.ca8bfc8f.svg";
export { SvgComponent as ReactComponent };